import React from 'react';
import { useSetAtom } from 'jotai';
import { RESET } from 'jotai/utils';
import { drawerAtom } from '../atoms/drawer.atom';
import { MLAnnotationsHeader } from './ml-annotations-header';
import { MLAnnotationsPanel } from './ml-annotations-panel';
const ML_ANNOTATION_DRAWER_PROPS = {
  title: () => <MLAnnotationsHeader />,
  component: () => <MLAnnotationsPanel />,
  isOpen: true,
  styles: {
    contentContainerStyles: {
      overflow: 'hidden'
    }
  }
};
export const useMLAnnotationsDrawer = () => {
  const setDrawer = useSetAtom(drawerAtom);
  const close = () => {
    setDrawer(RESET);
  };
  const open = () => {
    setDrawer({
      ...ML_ANNOTATION_DRAWER_PROPS,
      onClose: close
    });
  };
  return {
    open,
    close
  };
};